import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import SnackStore from '../../../stores/SnackStore';
import ConcurrencyPopUp from '../../ConcurrencyPopUp/ConcurrencyPopUp';
import PolicyTable from '../PolicyTable';
import PriorityModal from '../PriorityModal';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../../stores/ConsoleStore';
import { FTBody, Page } from '../../Fuse';
import BrowsingRoleModal from '../BrowsingRoles/BrowsingRoleModal';
import CustomCategoriesModal from '../CustomCategories/CustomCategoriesModal';
import FileRulesStore from '../../../stores/Policy/FileRules/FileRulesStore';
import FileRuleModal from './FileRuleModal';
import FuseAlert from '../../FuseControls/FuseAlert';

class FileRules extends Component {
    static propTypes = {
        store: FileRulesStore.PropType,
        console: ConsoleStore.PropType,
        snack: SnackStore.PropType.isRequired,
        itemNameFull: PropTypes.string.isRequired,
        readOnly: PropTypes.bool,
        ruleType: PropTypes.string.isRequired,
        showPreviewAction: PropTypes.bool,
        showMalwareCondition: PropTypes.bool,
        showDetectorSetsCondition: PropTypes.bool,
        scanLabel: PropTypes.string.isRequired,
        scanFileSize: PropTypes.number.isRequired,
        fileScanType: PropTypes.string.isRequired,
        renderName: PropTypes.func,
        tableSubHeaderText: PropTypes.string,
    };

    columnsConfig = {
        extraColumns: [{
            name: 'action',
            title: 'Action',
            render: (item) => <div> {this.fetchActionLabel(item.action)} </div>,
            index: PolicyTable.COL_INDEXES.DESCRIPTION + 1,
        }]
    };

    fetchActionLabel = (action) => {
        if (action === 'ALLOW') {
            return 'Allow';
        }
        if (action === 'BLOCK') {
            return 'Block';
        }
        if (action === 'PREVIEW') {
            return 'Block & Preview';
        }
        if (action === 'SCAN') {
            return this.props.scanLabel;
        }
    };

    tableSubheader = () => (this.props.tableSubHeaderText ? <FuseAlert
        type="success"
        icon="info"
        style={{ margin: '5px 16px 20px 16px' }}
    >
        <FTBody>{this.props.tableSubHeaderText}</FTBody>
    </FuseAlert> : null) ;


    componentDidMount = () => {
        const { showDetectorSetsCondition } = this.props;
        this.props.store.policyTable.policyModal.sections.matchCriteria.preload();
        if (showDetectorSetsCondition) {
            this.props.store.policyTable.policyModal.sections.additionalConditions.preload();
        }
    }

    renderTable = (priorityMode) => {
        const { store, snack, console, itemNameFull, renderName } = this.props;

        return <PolicyTable
            changePriorityAction
            store={store.policyTable}
            snack={snack}
            priorityMode={priorityMode}
            searchPlaceholder="Search by Name"
            noItemsText={'adding a ' + itemNameFull.toLowerCase()}
            itemName="Rule"
            subHeader={this.tableSubheader()}
            itemNameFull={itemNameFull}
            loadFailedMessage="Failed to load rules."
            readOnly={console.authority === ROLE_READ_ONLY.value || this.props.readOnly}
            columnsConfig={this.columnsConfig}
            renderName={renderName}
        />;
    }

    render() {
        const { store, itemNameFull, ruleType, children } = this.props;

        return <Fragment>
            <Page title={`Policies - ${itemNameFull}s`}>
                {this.renderTable()}
                {children}
            </Page>
            <FileRuleModal {...this.props} />
            <BrowsingRoleModal />
            <CustomCategoriesModal />

            <PriorityModal
                store={store.policyTable}
                subTitle={` - ${itemNameFull}s`}
                errMsg={'Failed to change rules priorities'}
            >
                {this.renderTable(true)}
            </PriorityModal>

            <ConcurrencyPopUp
                store={store.policyTable.concurrencyPopUpStore}
                revisionType={ruleType}
            />
        </Fragment>;
    }
}

export default inject('console', 'snack')(observer(FileRules));
